// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
import OverallPeriod from "./OverallPeriod";
import PerspectiveChip from "./PerspectiveChip";
import PerspectiveName from "./PerspectiveName";
import PerspectivePeriod from "./PerspectivePeriod";

const useOverallHeaderStyles = makeThemedStyles("OverallHeader", (theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

const OverallHeader = (
  props: React.PropsWithChildren<{ title?: string; periodName?: string }>
) => {
  const styles = useOverallHeaderStyles();
  return (
    <div className={styles.root}>
      <PerspectiveName>{props.title}</PerspectiveName>
      <OverallPeriod>{props.periodName}</OverallPeriod>
      {props.children}
    </div>
  );
};

export default OverallHeader;
